import React, { useState } from "react";
import { Row, Col } from "reactstrap";
import { useAuth } from "../../Context/AuthContext";
import DeleteIcon from "./../../Images/black-x.png";
import { useDispatch, useSelector } from "react-redux";
import { getErrorMessage } from "../../Redux/Actions/errorMessage";

const Card = ({ data, setHeadingFocused }) => {
  const { editLocalData, editLocalNumberData, deleteLocalData } = useAuth();
  const [cardFocused, setCardFocused] = useState(false);
  const currentPage = useSelector((state) => state.activePage);

  const dispatch = useDispatch();

  function handleEdit(e, id) {
    const regex = /^(\d+(\.\d{0,5})?|\.?\d{1,2})$/;
    if (e.target.name.includes("costs") || e.target.name.includes("hours")) {
      if (e.target.value.match(regex)) {
        editLocalNumberData(e, id);
      } else if (e.target.value === "") {
        editLocalNumberData(e, id);
        handleZero(e);
      } else {
        e.target.value = e.target.value.replace(/[^/\d\d{1,2}]/g,'')
        dispatch(
          getErrorMessage(
            `Felaktig inmatning i ${currentPage}, var god skriv in siffror!`
          )
        );
        const delayEditData = setTimeout(() => {
          dispatch(getErrorMessage(""));
        }, 5000);
        return () => clearTimeout(delayEditData);
      }
    } else {
      editLocalData(e, id);
    }
  }
  //if input is 0 select/highlight 0
  function handleZero(e) {
    if (e.target.value === "0") {
      e.target.select();
    }
  }

  function handleDelete(id) {
    deleteLocalData(id);
  }

  //calculations

  function addPerYear(valueA, valueB, valueC) {
    let a = parseFloat(valueA);
    let b = parseFloat(valueB);
    let c = parseFloat(valueC);
    let result = a + b + c;
    if (isNaN(result) || !isFinite(result)) {
      return "";
    } else {
      // hide decimal if none
      if (result % 1 === 0) {
        return (result = parseInt(result, 10));
      } else {
        return (result = parseFloat(result, 10).toFixed(1));
      }
    }
  }
  return (
    <Row
      className={`
        g-0 mt-2 m-auto rounded-3 
        ${cardFocused ? "cards-focused" : "cards"} 
      `}
      onFocus={() => setCardFocused(true)}
      onBlur={() => setCardFocused(false)}
    >
      <Col xs={5} className="p-2" style={{ padding: "0px" }}>
        <input
          type="text"
          className={` 
            form-control text-center 
            ${cardFocused ? "input-element-focused" : "input-element"}
          `}
          name="measureName"
          autoComplete="off"
          maxLength="30"
          defaultValue={data.object.measureName}
          onChange={(e) => handleEdit(e, data.id)}
          onFocus={(e) => setHeadingFocused(e.target.name)}
          onBlur={() => setHeadingFocused("")}
        />
      </Col>

      <Col xs={2} className="p-2" style={{ padding: "0px" }}>
        <select
          className={` 
            form-select input-priority 
            ${cardFocused ? "input-element-focused" : "input-element"}
          `}
          name="priority"
          autoComplete="off"
          defaultValue={data.object.priority}
          onChange={(e) => handleEdit(e, data.id)}
          onFocus={(e) => setHeadingFocused(e.target.name)}
          onBlur={() => setHeadingFocused("")}
        >
          {/*<option selected>{priority}</option>*/}
          <option value="1">1</option>
          <option value="2">2</option>
          <option value="3">3</option>
        </select>
      </Col>

      <Col xs={4} className="p-2" style={{ padding: "0px" }}>
        <input
          type="date"
          className={` 
            form-control input-date
            ${cardFocused ? "input-element-focused" : "input-element"}
          `}
          name="startdate"
          autoComplete="off"
          defaultValue={data.object.startdate}
          onChange={(e) => handleEdit(e, data.id)}
          onFocus={(e) => setHeadingFocused(e.target.name)}
          onBlur={() => setHeadingFocused("")}
        />
      </Col>
      <Col xs={4} className="p-2" style={{ padding: "0px" }}>
        <input
          type="date"
          className={` 
            form-control input-date
            ${cardFocused ? "input-element-focused" : "input-element"}
          `}
          name="enddate"
          autoComplete="off"
          defaultValue={data.object.enddate}
          onChange={(e) => handleEdit(e, data.id)}
          onFocus={(e) => setHeadingFocused(e.target.name)}
          onBlur={() => setHeadingFocused("")}
        />
      </Col>

      <Col xs={2} className="p-2" style={{ padding: "0px" }}>
        <input
          type="text"
          className={` 
            form-control text-center
            ${cardFocused ? "input-element-focused" : "input-element"}
          `}
          name="responsible"
          autoComplete="off"
          maxLength="3"
          defaultValue={data.object.responsible}
          onChange={(e) => handleEdit(e, data.id)}
          onFocus={(e) => setHeadingFocused(e.target.name)}
          onBlur={() => setHeadingFocused("")}
        />
      </Col>

      <Col xs={2} className="offset-1 p-2" style={{ padding: "0px" }}>
        <input
          type="text"
          className={` 
            form-control text-center
            ${cardFocused ? "input-element-focused" : "input-element"}
          `}
          name="hours1"
          autoComplete="off"
          maxLength="4"
          defaultValue={data.object.hours1 === 0 ? "" : data.object.hours1}
          onChange={(e) => handleEdit(e, data.id)}
          onFocus={(e) => setHeadingFocused(e.target.name)}
          onBlur={() => setHeadingFocused("")}
          onClick={(e) => handleZero(e)}
        />
      </Col>
      <Col xs={2} className="p-2" style={{ padding: "0px" }}>
        <input
          type="text"
          className={` 
            form-control text-center
            ${cardFocused ? "input-element-focused" : "input-element"}
          `}
          name="hours2"
          autoComplete="off"
          maxLength="4"
          defaultValue={data.object.hours2 === 0 ? "" : data.object.hours2}
          onChange={(e) => handleEdit(e, data.id)}
          onFocus={(e) => setHeadingFocused(e.target.name)}
          onBlur={() => setHeadingFocused("")}
          onClick={(e) => handleZero(e)}
        />
      </Col>
      <Col xs={2} className="p-2" style={{ padding: "0px" }}>
        <input
          type="text"
          className={` 
            form-control text-center
            ${cardFocused ? "input-element-focused" : "input-element"}
          `}
          name="hours3"
          autoComplete="off"
          maxLength="4"
          defaultValue={data.object.hours3 === 0 ? "" : data.object.hours3}
          onChange={(e) => handleEdit(e, data.id)}
          onFocus={(e) => setHeadingFocused(e.target.name)}
          onBlur={() => setHeadingFocused("")}
          onClick={(e) => handleZero(e)}
        />
      </Col>
      <Col xs={3} className="p-2" style={{ padding: "0px" }}>
        <output
          className={` 
            form-control text-center
            ${cardFocused ? "output-element-focused" : "output-element"}
          `}
          name="hours-total"
        >
          {addPerYear(
            data.object.hours1,
            data.object.hours2,
            data.object.hours3
          )}
        </output>
      </Col>

      <Col xs={3} className="p-2" style={{ padding: "0px" }}>
        <input
          type="text"
          className={` 
            form-control text-center
            ${cardFocused ? "input-element-focused" : "input-element"}
          `}
          name="costs1"
          autoComplete="off"
          maxLength="7"
          defaultValue={data.object.costs1 === 0 ? "" : data.object.costs1}
          onChange={(e) => handleEdit(e, data.id)}
          onFocus={(e) => setHeadingFocused(e.target.name)}
          onBlur={() => setHeadingFocused("")}
          onClick={(e) => handleZero(e)}
        />
      </Col>
      <Col xs={3} className="p-2" style={{ padding: "0px" }}>
        <input
          type="text"
          className={` 
            form-control text-center
            ${cardFocused ? "input-element-focused" : "input-element"}
          `}
          name="costs2"
          autoComplete="off"
          maxLength="7"
          defaultValue={data.object.costs2 === 0 ? "" : data.object.costs2}
          onChange={(e) => handleEdit(e, data.id)}
          onFocus={(e) => setHeadingFocused(e.target.name)}
          onBlur={() => setHeadingFocused("")}
          onClick={(e) => handleZero(e)}
        />
      </Col>
      <Col xs={3} className="p-2" style={{ padding: "0px" }}>
        <input
          type="text"
          className={` 
            form-control text-center
            ${cardFocused ? "input-element-focused" : "input-element"}
          `}
          name="costs3"
          autoComplete="off"
          maxLength="7"
          defaultValue={data.object.costs3 === 0 ? "" : data.object.costs3}
          onChange={(e) => handleEdit(e, data.id)}
          onFocus={(e) => setHeadingFocused(e.target.name)}
          onBlur={() => setHeadingFocused("")}
          onClick={(e) => handleZero(e)}
        />
      </Col>
      <Col xs={3} className="p-2" style={{ padding: "0px" }}>
        <output
          className={` 
            form-control text-center
            ${cardFocused ? "output-element-focused" : "output-element"}
          `}
          name="costs-total"
        >
          {addPerYear(
            data.object.costs1,
            data.object.costs2,
            data.object.costs3
          )}
        </output>
      </Col>
      <Col
        xs={1}
        className={` 
          pe-2 d-flex align-items-center
          ${cardFocused ? "cards-delete-button-focused" : "cards-delete-button"}
        `}
        onClick={() => handleDelete(data.id)}
      >
        <img
          src={DeleteIcon}
          alt="Delete icon"
          className="img-fluid max-width:100% height:auto mx-auto d-block w-50"
        />
      </Col>
    </Row>
  );
};
export default Card;
